const lang = {
    "de": {
        "message-too-long": "Maximal 200 Zeichen",
        "message-empty":  "Bitte geben Sie eine Nachricht ein",
        "welcome-header": "Guten Tag!",
        "iam": "Ich bin",
        "how-to-help": "Wie kann ich Ihnen helfen?",
        "send-message": "Sende eine Nachricht"
    },
    "en": {
        "message-too-long": "Maximal 200 characters",
        "message-empty":  "Please enter a message",
        "welcome-header": "Hi there!",
        "iam": "I am",
        "how-to-help": "How can I help you?",
        "send-message": "Send a message"
    }
};

export default lang;